import { render } from "./purchasesummary.vue?vue&type=template&id=29b4646f"
import script from "./purchasesummary.vue?vue&type=script&lang=js"
export * from "./purchasesummary.vue?vue&type=script&lang=js"

import "./purchasesummary.vue?vue&type=style&index=0&id=29b4646f&lang=css"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__